module.exports = __webpack_public_path__ + "static/media/coinIcon.be588b6a.svg";